import { IMAGES, APP_SCREENSHOTS, LINKS, CONTENT } from "../../const/config";
import { AndroidIcon, AppleIcon, PlatformDownload, ImageCarousel } from "../../components/home/Index";
import Footer from "../../components/Footer";
import { useStoreLinks } from "../../hooks/useStoreLinks";

export default function MobileView({ device }) {
  const isAndroid = device === "android";
  const { links: storeLinks } = useStoreLinks();

  const platformData = isAndroid
    ? {
        icon: <AndroidIcon />,
        title: "Android",
        directLink: LINKS.android.direct,
        storeLink: storeLinks.android,
      }
    : {
        icon: <AppleIcon />,
        title: "iOS",
        directLink: LINKS.ios.direct,
        storeLink: storeLinks.ios,
      };

  return (
    <div className="min-h-screen bg-white flex flex-col" style={{ fontFamily: "'Montserrat', sans-serif" }}>

      {/* ─── Header bar ─── */}
      <header className="w-full bg-blue-600 py-4 flex justify-center">
        <img
          src={IMAGES.logo}
          alt="Colascore"
          className="w-auto h-12 object-contain"
        />
      </header>

      <main className="flex-1 w-full max-w-lg mx-auto px-5 py-8 flex flex-col items-center gap-8">

        {/* ─── Title ─── */}
        <div className="text-center">
          <h1 className="text-xl font-bold text-gray-800 leading-snug">
            {CONTENT.header.title}
          </h1>
          <p className="text-gray-400 text-xs mt-1.5">
            {CONTENT.header.subtitle}
          </p>
        </div>

        {/* ─── Carousel ─── */}
        <div className="w-full flex flex-col items-center">
          <ImageCarousel images={APP_SCREENSHOTS} />
        </div>

        {/* ─── Download ─── */}
        <div className="w-full bg-gray-50 rounded-2xl p-6 flex flex-col items-center gap-4">
          <p className="text-xs text-gray-400 uppercase font-semibold tracking-wider">
            {CONTENT.labels.downloadApp}
          </p>
          <PlatformDownload {...platformData} />
        </div>
      </main>

      <Footer />
    </div>
  );
}